import ApiService from '../amplify/APIService';
import { push_notification } from './fetchActions';
import { NotificationType } from "../firebase/notifications/constant";

export const APTM_IN_PROGRESS_LOADING_ACTION = 'APTM_IN_PROGRESS_LOADING_ACTION';
export const APTM_IN_PROGRESS_LOADED_ACTION = 'APTM_IN_PROGRESS_LOADED_ACTION';
export const APTM_IN_PROGRESS_LOAD_FAILED_ACTION = 'APTM_IN_PROGRESS_LOAD_FAILED_ACTION';
export const APTM_TECH_LOCATION_UPDATE_ACTION = 'APTM_TECH_LOCATION_UPDATE_ACTION';

const aptmInProgressLoading = () => ({ type: APTM_IN_PROGRESS_LOADING_ACTION });
const aptmInProgressLoaded = data => ({ type: APTM_IN_PROGRESS_LOADED_ACTION, data });
const loadAptmInProgressFailed = error => ({ type: APTM_IN_PROGRESS_LOAD_FAILED_ACTION, error });
export const aptmTechLocationUpdate = loc => ({ type: APTM_TECH_LOCATION_UPDATE_ACTION, data: loc });

export function loadAptmInProgress() {
    return async (dispatch) => {
        dispatch(aptmInProgressLoading());
        let { ok, data } = await ApiService.loadAptmInProgress();
        if (ok) {
            if (data.founded) {
                dispatch(aptmInProgressLoaded(data));
                dispatch(push_notification({
                    type: NotificationType.techOnTheWay,
                    title: 'Technician on the way',
                    body: 'Our technician is going to fix you devices.'
                }));
            }
        } else {
            dispatch(loadAptmInProgressFailed());
        }
    };
}
